import { createContext, useContext, useState } from 'react'

const AppContext = createContext({})

const AppProvider = (props) => {
  const [visible, setVisible] = useState(false)

  const value = { visible, setVisible }
  return <AppContext.Provider value={value} {...props} />
}

const useApp = () => useContext(AppContext)

export { AppProvider, useApp }
